import { render, staticRenderFns } from "./AlertInvitation.vue?vue&type=template&id=4e45b128&scoped=true"
import script from "./AlertInvitation.vue?vue&type=script&lang=js"
export * from "./AlertInvitation.vue?vue&type=script&lang=js"
import style0 from "./AlertInvitation.vue?vue&type=style&index=0&id=4e45b128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45b128",
  null
  
)

export default component.exports